<template>
  <v-dialog v-model="dialog" max-width="800px">
    <v-overlay :value="loading" absolute opacity="0.7">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </v-overlay>
    <v-card>
      <v-card-title>新增章节</v-card-title>
      <v-card-text>
        <!-- 影片播放區域 -->
        <div class="video-player-container mb-6">
          <video
            v-if="previewUrl"
            controls
            class="video-player"
            :src="previewUrl"
          >
            您的浏览器不支持 HTML5 视频播放
          </video>
          <div v-else class="video-placeholder d-flex align-center justify-center">
            <span class="grey--text">暂无视频</span>
          </div>
        </div>
        <!-- 上传按钮 -->
        <!-- <div class="upload-button-container"> -->
          <div class="d-flex justify-end">
            <v-btn
              color="primary"
              @click="triggerFileInput"
            >
              {{ formData.videoFile ? '更换视频' : '上传视频' }}
            </v-btn>
          </div>

        <!-- 隱藏的文件輸入框 -->
        <input
          ref="fileInput"
          type="file"
          accept="video/*"
          style="display: none"
          @change="handleFileChange"
        >

        <v-form ref="form" v-model="valid">
          <div class="px-4">
            <!-- 课程名称 -->
            <div class="d-flex align-center mb-4">
              <v-text-field
                v-model="formData.lessonName"
                label="章节名称"
                :rules="[v => !!v || '请输入章节名称']"
                required
                class="flex-grow-1 mr-2"
              ></v-text-field>
            </div>

            <!-- 课程描述 -->
            <div class="mb-4">
              <v-textarea
                v-model="formData.description"
                label="章节描述"
                rows="3"
                counter="200"
                :rules="[v => v.length <= 200 || '描述不能超过200个字符']"
                placeholder="请输入章节描述"
              ></v-textarea>
            </div>
            <div class="mb-4">
              <v-text-field
                v-model.number="formData.sortOrder"
                type="number"
                label="排序"
                :rules="[v => v >= 0 || '排序值必须≥0']"
              ></v-text-field>
            </div>
          </div>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">取消</v-btn>
        <v-btn 
          color="blue darken-1" 
          text 
          @click="submit"
          :disabled="!isValid"
        >确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { courseApi } from '@/api/course'
import axiosInstance from '@/utils/httpUtil'
import { uploadMultipartFile } from '@/utils/ossUploader'

export default {
  name: 'CreateCourseLessonPopup',
  data() {
    return {
      loading: false,
      dialog: false,
      valid: false,
      previewUrl: null,
      formData: {
        courseTopicId: '',
        lessonName: '',
        description: '',
        videoFile: null,
        fileExtension: ''
      }
    }
  },
  computed: {
    isValid() {
      return this.formData.courseTopicId && 
             this.formData.lessonName && 
             this.formData.videoFile;
    }
  },
  methods: {
    open(topicId) {
      this.resetForm(topicId);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.resetForm();
    },
    resetForm(topicId = null) {
      const newTopicId = topicId || this.formData.courseTopicId;
      
      this.formData = {
        courseTopicId: newTopicId,
        lessonName: '',
        description: '',
        videoFile: null,
        fileExtension: '',
        sortOrder: 0  // Default sort order value
      };
      
      if (this.previewUrl) {
        URL.revokeObjectURL(this.previewUrl);
        this.previewUrl = null;
      }
      
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        if (this.previewUrl) {
          URL.revokeObjectURL(this.previewUrl);
        }
        const extension = file.name.substring(file.name.lastIndexOf('.') + 1);
        this.formData.fileExtension = extension;
        this.formData.videoFile = file;
        this.previewUrl = URL.createObjectURL(file);
      }
      event.target.value = '';
    },
    // async submit() {
    //   if (!this.$refs.form.validate() || !this.isValid) return;

    //   try {
    //     const formData = new FormData();
    //     formData.append('videoFile', this.formData.videoFile);

    //     await courseApi.createLesson({
    //       courseTopicId: this.formData.courseTopicId,
    //       lessonName: this.formData.lessonName,
    //       description: this.formData.description,
    //       videoFile: formData
    //     });

    //     this.$emit('lesson-created');
    //     this.close();
    //     this.$toast.success('章节创建成功');
    //   } catch (error) {
    //     const errorMessage = error.response?.data?.message || error.message || '未知错误';
    //     this.$toast.error('创建失败：' + errorMessage);
    //   }
    // }
    // 单档直传OSS
    async uploadToOSS(file, stsData) {
      const formData = new FormData();
      formData.append('key', stsData.key);
      formData.append('OSSAccessKeyId', stsData.accessId);
      formData.append('policy', stsData.policy);
      formData.append('Signature', stsData.signature);
      formData.append('success_action_status', '200');
      formData.append('callback', stsData.callback);
      formData.append('file', file);

      const resp = await axiosInstance.post(stsData.host, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      return resp.data;
    },

    // upload oss 单档
    // async submit() {
    //   const response = await courseApi.getUploadStsUrl('VideoCourse', 'mp4');
    //   console.log('get upload sts url resp : ', response);
    //   if(response.code === "2000") {
    //     console.log('get upload sts url resp data : ', response.data);
    //     const resp = await this.uploadToOSS(this.formData.videoFile, response.data);
    //     console.log('upload to oss resp : ', resp);
    //   }
    // }
    async submit() {
      // 0. check form valid
      if (!this.$refs.form.validate() || !this.isValid) return;
      this.loading = true;
      try {
        // 1. 请求后端获取STS凭证和上传参数
        const params = {
            type: 'VideoCourse',
            fileExtension: this.formData.fileExtension,
            courseTopicId: this.formData.courseTopicId,
            lessonName: this.formData.lessonName,
            description: this.formData.description,
            sortOrder: this.formData.sortOrder,
          };
        const createdStsResp = await courseApi.getUploadMultipartUrl(params);

        const sts = createdStsResp.data;
        // 2. 上传到OSS, 分片上传
        await uploadMultipartFile(this.formData.videoFile, sts, null);
      
        this.$emit('lesson-created');
        this.close();
        this.$toast.success('章节创建成功');
      } catch(error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('创建失败：' + errorMessage);
      } finally {
        this.loading = false;
      }

    }
  },
  
  beforeDestroy() {
    if (this.previewUrl) {
      URL.revokeObjectURL(this.previewUrl);
    }
  }
}
</script>

<style scoped>
.video-player-container {
  width: 100%;
  height: 400px;
  background-color: #f5f5f5;
  border-radius: 4px;
  overflow: hidden;
  position: relative;
}

.video-player {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.video-placeholder {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  border-radius: 4px;
}

.upload-button-container {
  position: absolute;
  bottom: 16px;
  right: 16px;
  z-index: 1;
}
</style> 